<template>
  <div class="upcoming-events-week-slider-container">
    <div class="week-slider-today">Сегодня</div>
    <div class="upcoming-events-week-slider-btn-left"><week-slider-btn-left/></div>
    <div class="upcoming-events-week-slider">
      <week-slider/>
    </div>
    <div><week-slider-btn-right/></div>
  </div>
</template>
<script>
  import WeekSlider from './WeekSlider.vue'
  import WeekSliderBtnLeft from './WeekSliderBtnLeft.vue'
  import WeekSliderBtnRight from './WeekSliderBtnRight.vue'
  export default {
    name: 'UpcomingEventsWeekSlider',
    components: {
      WeekSlider,
      WeekSliderBtnLeft,
      WeekSliderBtnRight
    }
  }
</script>